export enum BUTTON_TAGS {
    BUTTON = 'BUTTON',
    SH_BUTTON = 'SH_BUTTON'
}
